import setup from './moduleSetup';

export default {
    name: 'shipment',
    before: [],
    after: [],
    setup,
};
